import React from 'react';
import DebouncingInput from "../../elements/DebouncingInput";
import {useSelector} from "react-redux";
import UseSetParams from "./UseSetParams";
import {getFilter} from "../../../store/TableRedux/TableRedux";

const DebouncingInputFilter = ({data}) => {
    const filter = useSelector((state) => state.TableRedux.filter);
    const [handleSetParams,] = UseSetParams(getFilter)
    const funcHandleSetParams = (newFilter) => {
        handleSetParams(newFilter)
    }

    const {filterName, placeholder,className} = data
    return (
        <DebouncingInput placeholder={placeholder} className={`form-control ${className}`} type='text'
                         defaultValue={filter[filterName]} onChange={(e) => {
            funcHandleSetParams([{key: filterName, value: e}])
        }}

        />
    );
};

export default DebouncingInputFilter;